/**
 * Servicio API del modulo de Certificaciones
 * Ubicacion: src/services/certificacionesApi.js
 */

import axios from 'axios';

const getApiBaseUrl = () => {
  const baseUrl = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');
  return `${baseUrl}/certificaciones`;
};

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 45000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Token vencido o invalido: se limpia la sesion y se vuelve al login.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

const listar = (ruta) => (params = {}) =>
  api.get(ruta, { params, paramsSerializer: { indexes: null } }).then(r => r.data);

export const certificacionesApi = {
  getEnums: () => api.get('/meta/enums').then(r => r.data),
  getResumen: () => api.get('/resumen').then(r => r.data),

  // Catalogo de examenes (pestana Fabricante del sheet)
  listCatalogo: listar('/catalogo'),
  createCatalogo: (payload) => api.post('/catalogo', payload).then(r => r.data),
  updateCatalogo: (id, payload) => api.put(`/catalogo/${id}`, payload).then(r => r.data),
  deleteCatalogo: (id) => api.delete(`/catalogo/${id}`).then(r => r.data),

  // Colaboradores
  listColaboradores: listar('/colaboradores'),
  createColaborador: (payload) => api.post('/colaboradores', payload).then(r => r.data),
  updateColaborador: (correo, payload) =>
    api.put(`/colaboradores/${encodeURIComponent(correo)}`, payload).then(r => r.data),
  deleteColaborador: (correo) =>
    api.delete(`/colaboradores/${encodeURIComponent(correo)}`).then(r => r.data),

  // Examenes presentados
  listExamenes: listar('/examenes'),
  createExamen: (payload) => api.post('/examenes', payload).then(r => r.data),
  updateExamen: (id, payload) => api.put(`/examenes/${id}`, payload).then(r => r.data),
  deleteExamen: (id) => api.delete(`/examenes/${id}`).then(r => r.data),
  uploadComprobante: (examenId, file) => {
    const form = new FormData();
    form.append('examen_id', examenId);
    form.append('archivo', file);
    return api.post('/examenes/comprobante', form, { headers: { 'Content-Type': undefined } })
      .then(r => r.data);
  },

  // Cursos
  listCursos: listar('/cursos'),
  listProgramas: () => api.get('/cursos/programas').then(r => r.data),
  createCurso: (payload) => api.post('/cursos', payload).then(r => r.data),
  updateCurso: (id, payload) => api.put(`/cursos/${id}`, payload).then(r => r.data),
  deleteCurso: (id) => api.delete(`/cursos/${id}`).then(r => r.data),
};

export { apiErrorMessage } from './alianzasApi';

export default certificacionesApi;
